/**
 * Created by user on 2019/7/29.
 */

/**
 * 隱藏資料 用來處理特殊需求
 */
export const SymSelf = Symbol('self');
